<template>
  <div class="tsp-section-checks">
    <div class="tsp-section-title tsp-section-title--row">
      <span>{{ $t('tokenSecurityData.testItems') }}</span>
      <div class="tsp-check-legend">
        <el-tooltip
          popper-class="token-swap-popper token-swap-popper--enterable"
          placement="top"
          content="GoPlus"
          :enterable="true"
          manual
          v-model="platformTipMap['goPlus']"
          v-if="showGoPlus"
        >
          <img
            class="platforms"
            @mouseenter="platformTipMap['goPlus'] = true"
            @mouseleave="platformTipMap['goPlus'] = false"
            :src="goPlusIcon"
            alt=""
          />
        </el-tooltip>
        <el-tooltip
          popper-class="token-swap-popper token-swap-popper--enterable"
          placement="top"
          content="Certik"
          :enterable="true"
          manual
          v-model="platformTipMap['certik']"
          v-if="showCertik"
        >
          <img
            class="platforms"
            @mouseenter="platformTipMap['certik'] = true"
            @mouseleave="platformTipMap['certik'] = false"
            :src="certikIcon"
            alt=""
          />
        </el-tooltip>
      </div>
    </div>

    <div class="tsp-checks">
      <TokenSecurityCheckRow
        v-for="(row, idx) in securityList"
        :checkRow="row"
        :isSol="isSol"
        :epoch="epoch"
        :key="idx"
        :showGoPlus="showGoPlus"
        :showCertik="showCertik"
      />
    </div>
  </div>
</template>

<script>
import TokenSecurityCheckRow from './TokenSecurityCheckRow.vue';

export default {
  name: 'TokenSecurityChecks',
  components: {
    TokenSecurityCheckRow,
  },
  props: {
    securityList: {
      type: Array,
      default: () => [],
    },
    isSol: {
      type: Boolean,
    },
    epoch: {
      type: Number,
    },
    showGoPlus: {
      type: Boolean,
      default: true,
    },
    showCertik: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      platformTipMap: {},
    };
  },
  computed: {
    goPlusIcon() {
      return require(`@/assets/token-security/go+.png`);
    },
    certikIcon() {
      return require(`@/assets/token-security/Certik.png`);
    },
  },
};
</script>

<style scoped lang="scss">
.tsp-section-title {
  font-size: 18px;
  font-weight: 500;
  color: var(--color-29);

  &--row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.tsp-section-checks {
  flex: 1 1;
  min-height: 0;

  .tsp-check-legend {
    display: flex;
    gap: 12px;

    img {
      width: 20px;
      height: 20px;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .tsp-checks {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

@media screen and (max-width: 767px) {
  .tsp-section-title {
    font-size: 14px;
  }
}
</style>
